import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryDhlForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-dhl',
  templateUrl: './dhl.component.html',
  styleUrls: ['./dhl.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DhlComponent {
  delivery = input<DeliveryDhlForm>();
}
